import React from 'react';
import { Code2 } from 'lucide-react';

const Technologies = () => {
  const technologies = [
    {
      name: 'Angular',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <path fill="#DD0031" d="M12 2L2 6.5l1.5 13L12 22l8.5-2.5 1.5-13L12 2z"/>
          <path fill="#C3002F" d="M12 2v20l8.5-2.5 1.5-13L12 2z"/>
          <path fill="#FFFFFF" d="M12 4.5L7.5 16h2l1-2.5h3L14.5 16h2L12 4.5zm0 3.5l1.5 4h-3l1.5-4z"/>
        </svg>
      )
    },
    {
      name: 'React',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <circle cx="12" cy="12" r="2" fill="#61DAFB"/>
          <ellipse cx="12" cy="12" rx="9" ry="3" stroke="#61DAFB" strokeWidth="1.5" fill="none"/>
          <ellipse cx="12" cy="12" rx="9" ry="3" stroke="#61DAFB" strokeWidth="1.5" fill="none" transform="rotate(60 12 12)"/>
          <ellipse cx="12" cy="12" rx="9" ry="3" stroke="#61DAFB" strokeWidth="1.5" fill="none" transform="rotate(120 12 12)"/>
        </svg>
      )
    },
    {
      name: 'Python',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <path fill="#3776AB" d="M12 2C7.5 2 8 4 8 4v2h4V7H5.5C3 7 2 9 2 12s1 5 3.5 5H7v-3c0-2 2-4 4-4h4c1.5 0 3-1.5 3-3V6c0-2-1.5-4-4-4h-2z"/>
          <path fill="#FFD43B" d="M12 22c4.5 0 4-2 4-2v-2h-4v-1h6.5c2.5 0 3.5-2 3.5-5s-1-5-3.5-5H17v3c0 2-2 4-4 4h-4c-1.5 0-3 1.5-3 3v4c0 2 1.5 4 4 4h2z"/>
          <circle cx="9.5" cy="5" r="1" fill="#FFF"/>
          <circle cx="14.5" cy="19" r="1" fill="#FFF"/>
        </svg>
      )
    },
    {
      name: 'HTML5',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <path fill="#E34F26" d="M3 2l1.5 17L12 22l7.5-3L21 2H3zm14 6h-7l.5 2h6.5l-.5 6-5 2-5-2-.5-3h2l.5 1.5 3 1 3-1 .5-3.5h-9l-1-6h12l-.5 2z"/>
        </svg>
      )
    },
    {
      name: 'CSS3',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <path fill="#1572B6" d="M3 2l1.5 17L12 22l7.5-3L21 2H3zm14 6h-8l.5 2H17l-.5 6-4.5 1.5-4.5-1.5-.5-3h2l.5 1.5 2.5 1 2.5-1 .5-3.5H8l-1-6h11l-.5 2z"/>
        </svg>
      )
    },
    {
      name: 'JavaScript',
      icon: (
        <svg viewBox="0 0 24 24" className="w-16 h-16">
          <rect width="22" height="22" x="1" y="1" fill="#F7DF1E" rx="2"/>
          <path fill="#000" d="M7 16c0 1 .5 2 2 2 1 0 1.5-.5 1.5-1.5V10H9v6.5c0 .5-.5.5-.5.5s-.5 0-.5-.5V16H7zm5 0c0 1.5 1 2 2.5 2 1 0 2-.5 2-1.5 0-1-.5-1.5-1.5-2l-.5-.5c-.5-.5-.5-.5-.5-1s.5-.5.5-.5.5 0 .5.5V13h1.5v-.5c0-1-.5-2-2-2s-2.5 1-2.5 2c0 1 .5 1.5 1.5 2l.5.5c.5.5.5.5.5 1s-.5.5-.5.5-.5 0-.5-.5V16H12z"/>
        </svg>
      )
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 rounded-full mb-4">
            <Code2 className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-medium text-blue-600">Technology Stack</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Technologies We <span className="text-blue-600">Master</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Leveraging modern frameworks and languages to build robust, scalable solutions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="group flex flex-col items-center p-6 bg-slate-50 rounded-2xl hover:bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="mb-4 group-hover:scale-110 transition-transform duration-300">
                {tech.icon}
              </div>
              <h3 className="text-lg font-semibold text-slate-900">{tech.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;